import { useState, useEffect } from "react";
// screens
import SplashScreen from "components/signupScreens/SplashScreen";
import StepOne from "components/signupScreens/StepOne";
import StepTwo from "components/signupScreens/StepTwo";
import StepThree from "components/signupScreens/StepThree";
import StepFour from "components/signupScreens/StepFour";
import StepFive from "components/signupScreens/StepFive";
import StepSix from "components/signupScreens/StepSix";
// axios for api calls
import axios from "axios";
// paging
import PaginationHeader from "components/signupScreens/PaginationHeader";
// signup form
import Form from "./Form";
// 
import { useSearchParams } from "react-router-dom";
import firebase, { auth } from "config/firebase";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import Spinner from "utils/Spinner";
import { setAuth } from "redux/reducers/authReducerSlice";
import QueryChecker from "utils/queryChecker";

let initial = {
  emotions: [],
  frequency: "",
  children: {},
  fullName: "",
  email: "",
  password: "",
};

const SignUp = () => {
  const dispatch = useDispatch();
  // active step state
  const [activeStep, setActiveStep] = useState(null);
  // form data
  const [formData, setFormData] = useState(initial);
  //
  const [searchParams] = useSearchParams();
  const paramsEmail = searchParams.get("email");
  //  emotions loading state
  const [emotionsLoading, setEmotionsLoading] = useState(true);
  // emotions data state
  const [emotionsData, setEmotionsData] = useState([]);
  //  ages loading state
  const [agesDataLoading, setAgesDataLoading] = useState(true);
  // ages data data state
  const [agesData, setAgesData] = useState([]);
  //  ages loading state
  const [isSubmitting, setIsSubmitting] = useState(false);
  // static frequency list
  const frequencyList = [
    { name: "once_wk", title: "Once (10 - 20 min)", mainTitle: "Once a week" },
    {
      name: "twice_wk",
      title: "Twice (20 - 40 min)",
      mainTitle: "Twice a week",
    },
    {
      name: "three_wk",
      title: "Three or more (45+ min)",
      mainTitle: "Three or more times in a week",
    },
  ];

  // signup
  const handleSignUp = (e) => {

    e.preventDefault();
    setIsSubmitting(true);
    auth
      .createUserWithEmailAndPassword(
        paramsEmail || formData.email,
        formData.password
      )
      .then(() => {
        firebase
          .auth()
          .currentUser.getIdToken()
          .then(function (idToken) {
            let leadDyno = window.LeadDyno
            leadDyno.recordLead( paramsEmail || formData.email)
            // Send token to backend
            axios({
              method: "POST",
              url: `${process.env.REACT_APP_MAMAZEN_API_BASE_URL}users`,
              data: {
                children: Object.values(formData?.children),
                lastName: "",
                firstName: formData.fullName,
                emailAddress: paramsEmail || formData.email,
                password: formData.password,
                frequency: formData.frequency || "once_wk",
                login: "email",
                emotions: formData.emotions,
              },
              headers: {
                "Content-Type": "application/json",
                "Authorization": idToken,
                "token_type": "firebase",
              },
            })
              .then((res) => {
                setActiveStep(null);
                setIsSubmitting(false);
                setFormData(initial);
                setTimeout(() => {
                  dispatch(
                    setAuth({
                      data: res.data,
                      isAuthenticated: true,
                      isLoading: false,
                    })
                  );
                }, 1450);
                // console.log(res);
              })
              .catch((err) => {
                setIsSubmitting(false);
                console.log(err);
                alert(err.message);
              });
          })
          .catch(function (error) {
            console.log("s-t =>", error);
          });
      })
      .catch((error) => {
        alert(error.message);
        console.log(error);
        setIsSubmitting(false);
      });
  };

  // total steps
  const steps = [
    <StepOne
      setActiveStep={setActiveStep}
      isLoading={emotionsLoading}
      emotionsData={emotionsData}
      formData={formData}
      setFormData={setFormData}
    />,
    <StepTwo setActiveStep={setActiveStep} />,
    <StepThree setActiveStep={setActiveStep} />,
    <StepFour
      setActiveStep={setActiveStep}
      formData={formData}
      setFormData={setFormData}
      frequencyList={frequencyList}
    />,
    <StepFive
      setActiveStep={setActiveStep}
      formData={formData}
      setFormData={setFormData}
      agesData={agesData}
      isLoading={agesDataLoading}
    />,
    <StepSix
      setActiveStep={setActiveStep}
      formData={formData}
      agesData={agesData}
      emotionsData={emotionsData}
      frequencyList={frequencyList}
    />,
    <Form
      formData={formData}
      setFormData={setFormData}
      isSubmitting={isSubmitting}
      handleSignUp={handleSignUp}
    />,
  ];

  //
  useEffect(() => {
    //  get Emotions data
    let getEmotionsData = () =>
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_MAMAZEN_API_BASE_URL}emotions?$limit=100&showOnOnboarding=true`,
        headers: {
          Authorization: "Basic bXotd2ViOmFkZiQjMjM0ZWY=",
        },
      })
        .then((res) => {
          let { data } = res;
          setEmotionsData(data?.data || []);
          setEmotionsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setEmotionsLoading(false);
        });
    //  get Age ranges data
    let getAgeRangesData = () =>
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_MAMAZEN_API_BASE_URL}ageRanges?$limit=100`,
        headers: {
          Authorization: "Basic bXotd2ViOmFkZiQjMjM0ZWY=",
        },
      })
        .then((res) => {
          let { data } = res;
          setAgesData(data?.data || []);
          setAgesDataLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setAgesDataLoading(false);
        });

    getEmotionsData();
    getAgeRangesData();
  }, []);

  const { isAuthenticated, isLoading } = useSelector((store) => store.auth);
  let location = useLocation();

  const withQuery = QueryChecker(["promo","email","sId"]);

  const { from } = location.state || { from: { pathname: "/myAccount" +withQuery} };

  if (isLoading)
    return (
      <div className="cs_container h_100 d_flex flex_col align_items_center justify_content_center text_center text_white">
        <Spinner />
      </div>
    );
  if (isAuthenticated) return <Navigate to={from?.pathname} replace />;

  return (
    <>
      {activeStep !== null ? (
        <section className="text_white text_center signup_card">
          <PaginationHeader activeStep={activeStep} steps={steps} />
          <br />
          {steps[activeStep]}
        </section>
      ) : (
        <SplashScreen activeStep={activeStep} setActiveStep={setActiveStep} />
      )}
    </>
  );
};

export default SignUp;
